import {
	type FetchSocialFeedByFeedSlugAndChilizIdParams,
	type JSONwithRefsType,
	minutesToMs,
	resolveJSONrefs,
	socialApi
} from '@capsicum/common';
import { type FetchMeActivities, type PostActivityType } from '@capsicum/socios-core';
import { type QueryKey, useInfiniteQuery } from '@tanstack/react-query';

export const useSocialFeedQuery = (key: QueryKey, params: FetchSocialFeedByFeedSlugAndChilizIdParams) => {
	const fetch = async (
		query: FetchSocialFeedByFeedSlugAndChilizIdParams
	): Promise<FetchMeActivities<PostActivityType>> => {
		const api = await socialApi;

		const response = await resolveJSONrefs(
			(await api.fetchSocialFeedByFeedSlugAndChilizId(query)) as unknown as JSONwithRefsType
		);

		return response as FetchMeActivities<PostActivityType>;
	};

	const queryFn = ({ pageParam = 0 }) => {
		const queryParams: FetchSocialFeedByFeedSlugAndChilizIdParams = {
			...params,
			offset: pageParam
		};

		return fetch(queryParams);
	};

	const { data, error, fetchNextPage, hasNextPage, isFetched, isFetching, isLoading, refetch } = useInfiniteQuery({
		enabled: !!params.chilizId,
		getNextPageParam: lastPage => {
			const nextOffset = lastPage.metadata.nextOffset;

			return nextOffset > 0 ? nextOffset : undefined;
		},
		initialPageParam: 0,
		queryFn,
		queryKey: key,
		staleTime: minutesToMs(10)
	});

	return { data, error, fetchNextPage, hasNextPage, isFetched, isFetching, isLoading, refetch };
};
